import * as constants from './constants';

export const toggleCustomizationButton = () => {
    const customizationButton = document.getElementById(constants.SPORTSBOOK_CUSTOMIZATION_BUTTON_ID);

    if (!customizationButton) {
        return;
    }

    customizationButton.classList.toggle('hidden');
};
